document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.menu-button');
  const nav = document.querySelector('.nav-bar');
  if (menu && nav) {
    menu.setAttribute('role', 'button');
    menu.setAttribute('aria-label', 'Toggle menu');
    menu.setAttribute('aria-expanded', 'false');
    menu.addEventListener('click', event => {
      event.preventDefault();
      const open = nav.classList.toggle('bythlon-menu-open');
      menu.setAttribute('aria-expanded', String(open));
    });
  }
  document.querySelectorAll('.lightbox_image').forEach(link => {
    const image = link.querySelector('img');
    if (image) link.href = image.currentSrc || image.src;
  });
  if (window.Swiper) {
    const initSliders = () => document.querySelectorAll('.testimonial-slider_component').forEach(component => {
      const slider = component.querySelector('.swiper');
      if (!slider || !slider.offsetWidth || slider.swiper) return;
      new window.Swiper(slider, {
        slidesPerView: 'auto',
        followFinger: true,
        freeMode: false,
        slideToClickedSlide: false,
        centeredSlides: false,
        autoHeight: false,
        speed: 300,
        slideActiveClass: 'is-active',
        slideDuplicateActiveClass: 'is-active',
        mousewheel: { forceToAxis: true },
        keyboard: { enabled: true, onlyInViewport: true },
        navigation: {
          nextEl: component.querySelector('.testimonial-slider_btn_element.is-next'),
          prevEl: component.querySelector('.testimonial-slider_btn_element.is-prev'),
        },
        pagination: {
          el: component.querySelector('.testimonial-slider_bullet_wrap'),
          bulletActiveClass: 'is-active',
          bulletClass: 'testimonial-slider_bullet_item',
          bulletElement: 'button',
          clickable: true,
        },
        scrollbar: {
          el: component.querySelector('.testimonial-slider_draggable_wrap'),
          draggable: true,
          dragClass: 'testimonial-slider_draggable_handle',
          snapOnRelease: true,
        },
      });
    });
    initSliders();
    window.addEventListener('resize', initSliders);
  }
});
